/**
 * Created by shaik on 11/09/16.
 */
define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var BaseFilterItem = require('web-agent-components/BaseFilterItemViewController');
    var TagViewController = require('web-agent-components/TagViewController');
    var ButtonMultiSelectionDropdownViewController = require('web-agent-components/ButtonMultiSelectionDropdownViewController');

    var FilterItemMultiSelectionDropdown = BaseFilterItem.extend({
        ControllerName: 'FilterItemMultiSelectionDropdownViewController',
        LPClassesMap: {
            dropdownSelection: ".lpview_dropdownSelection",
            tagsContainer: ".lpview_tagsContainer",
            tableContainer: ".list_table_container"
        },
        LPTemplatesFiles: {
            rowTemplateFile : "LP_multi_select_dropdown_row.html",
            filterDropdownSelection: "LP_filter_dropdown_selection_view.html"
        },

        initialize: function(constructorData) {
            this.itemsArray = constructorData.items || [];
            this.context = constructorData.context;
            this.filterDataModelPath = constructorData.filterDataModelPath;
            this.publishProperty = constructorData.publishProperty || "id";
            this.textProperty = constructorData.textProperty || "name";
            this.titleText = "{{filter_title_" + constructorData.filterTextSuffix + "}}";
            this.minusOneData = constructorData.minusOneData || null;
            this.selectedTag = {};

            this.viewInit();

        },
        events: function() {},
        render: function() {}
    });

    FilterItemMultiSelectionDropdown.prototype.viewInit = function() {
        var tableTemplate = require('web-agent-templates/' + this.LPTemplatesFiles.filterDropdownSelection);
        // var tableTemplate = lpUtils.loadResource(this.LPTemplatesFiles.filterDropdownSelection);
        this.createView({template: tableTemplate});

        // Add Dropdown
        this.ButtonDropdownVC = new ButtonMultiSelectionDropdownViewController({
            rowTemplateFile : this.LPTemplatesFiles.rowTemplateFile,
            items: this.itemsArray,
            context: this,
            rowsSortFunction: this.compare(this.textProperty),
            itemClicked: this.onDropdownChange,
            lostFocusCallback: onLostFocusCallback.bind(this.context),
            scrollableContainer: this.LPClassesMap.tableContainer,
            textProperty: this.textProperty,
            titleText: this.titleText
        });
        this.addViewController({viewController: this.ButtonDropdownVC, target: this.LPClassesMap.dropdownSelection});
    };

    FilterItemMultiSelectionDropdown.prototype.getValue = function() {
        var results = [];
        for (var i = 0; i < this.itemsArray.length; i++) {
            if (this.itemsArray[i].checked) {
                results.push(this.itemsArray[i][this.publishProperty]);
            }
        }
        return (results.length) > 0 ? results.toString() : undefined;
    };

    function onLostFocusCallback (e) {
        this.onLostFocus(e);
    }

    /**
     * This is the sorting function
     * @param field - the field of the name in the object
     * @returns {Function}
     */
    FilterItemMultiSelectionDropdown.prototype.compare = function (field) {
        function key (x) {
            return x[field];
        }
        return function (a, b) {
            if (parseInt(a.id, 10) < 0) { // if id = -1 then put ot top of the list
                return -1;
            } else if (parseInt(b.id, 10) < 0){
                return 1;
            }
            if (key(a).toLowerCase() < key(b).toLowerCase()) {
                return -1;
            }
            if (key(a).toLowerCase() > key(b).toLowerCase()) {
                return 1;
            }
            return 0;
        };
    };

    /**
     * Run on Dropdown change event. add tag and update select lists
     * @param data
     */
    FilterItemMultiSelectionDropdown.prototype.onDropdownChange = function (data) {
        if (data.rowData.checked){
            this.select(data.rowData);
        } else {
            this.unSelect(data.rowData);
        }
    };

    FilterItemMultiSelectionDropdown.prototype.addTagVC = function (id, name) {
        this.selectedTag[id] = new TagViewController({
            tagText: name,
            tagValue: id,
            context: this,
            closeCallback: this.closeTag
        });
        this.addViewController({viewController: this.selectedTag[id], target: this.LPClassesMap.tagsContainer});
    };

    /**
     * Run on close event. Remove the tag from the UI and update the select lists
     * @param id
     * @param context
     */
    FilterItemMultiSelectionDropdown.prototype.closeTag = function (id) {
        this.unSelect(id);
    };

    FilterItemMultiSelectionDropdown.prototype.select = function (id) {
        var item = this.getItem(id);
        // Add the tag to the UI
        if (!this.selectedTag[item[this.publishProperty]]) {
            this.addTagVC(item[this.publishProperty], item[this.textProperty]);
        }
        item.checked = true;
    };

    FilterItemMultiSelectionDropdown.prototype.unSelect = function (id,disableUpdate) {
        var item = this.getItem(id);
        // remove the tag
        this.removeViewController(this.selectedTag[item[this.publishProperty]]);
        this.selectedTag[item[this.publishProperty]] = null;
        // update the dropdown
        item.checked = false;

        if (!disableUpdate) {
            this.ButtonDropdownVC.modelChanged();
        }
    };

    /**
     * Returns selection item from itemsArray
     * @param {String|Object} id
     * @returns {Object|null}
     */
    FilterItemMultiSelectionDropdown.prototype.getItem = function (id){
        var itemId;
        if(_.isObject(id)) {
            itemId = id[this.publishProperty];
        } else {
            itemId = id;
        }
        for (var i = 0; i < this.itemsArray.length; i++) {
            if (String(this.itemsArray[i][this.publishProperty]) === String(itemId)) {
                return this.itemsArray[i];
            }
        }
        return null;
    };

    FilterItemMultiSelectionDropdown.prototype.getLatestItems = function () {
        this.controllerModelParam = window.App.agentController.getModelParam(this.filterDataModelPath);
        var list = this.controllerModelParam ? lpUtils.cloneObject(this.controllerModelParam) : [];
        if (this.minusOneData) {
            list.unshift(this.minusOneData);
        }
        return list;
    };

// set the tags and dropdown according to the data in the filter
    FilterItemMultiSelectionDropdown.prototype.updateFilterUI = function (filterUIData) {
        var i;
        // clear all UI and arrays
        for (i = 0; i < this.itemsArray.length; i++) {
            if (this.itemsArray[i].checked) {
                this.unSelect(this.itemsArray[i][this.publishProperty], true);
            }
        }
        this.selectedTag = {};

        // Get latest list
        if(this.filterDataModelPath) {
            this.itemsArray = this.getLatestItems();
        }

        // Set all selected
        if (filterUIData) {
            var list = filterUIData.split(",");
            for (i = 0; i < list.length; i++) {
                this.select(list[i], true);
            }
        }
        // Update the drupdown View Controller
        this.ButtonDropdownVC.updateModelData(this.itemsArray);
    };


    return FilterItemMultiSelectionDropdown;

});
